import React, { useEffect, useState } from "react";
import "./App.css";
import { storage } from "./config";
import { Card } from "antd";
import "antd/dist/antd.css";
import { Image } from "antd";
import firebase from "./config";
import { Spin } from "antd";
import { Menu, Dropdown } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { Checkbox } from "antd";
import { Input } from "antd";
import { useRecoilState } from "recoil";
import infoPorduct from "./recoil/atom";
import Popup from "reactjs-popup";
import { Progetto } from "./Progetto"

const { TextArea } = Input;

const { Meta } = Card;
function App() {
  const [image, setImage] = useState({});
  const [caricamento, setCaricamento] = useState(false);
  const [prezzo, setPrezzo] = useState(0);
  const [titolo, setTitolo] = useState("Titolo");
  const [categoria, setCategoria] = useState("Categoria");
  const [inforamzioni, setInfomrazioni] = useState("");
  const [caricato, setCaricato] = useState("");
  const [nuovo, setNuovo] = useState(false);
  const [url, setUrl] = useState(
    "https://bossicar.com/wp-content/uploads/2019/06/placeholder-image.jpg"
  );
  const [progetto, setProget] = useState("");

  const [text, setText] = useRecoilState(infoPorduct);

  function handlerChange(e) {
    if (e.target.files[0]) {
      // e.target.file[0];
      setImage(e.target.files[0]);
      console.log(e.target.files[0]);
    }
    //
  }
  function uppload(e) {
    setCaricamento(true);
    const uploadTask = storage.ref(`images/${image.name}`).put(image);
    uploadTask.on(
      "state_changed",
      (snapshot) => { },
      (error) => {
        console.log(error);
      },
      () => {
        storage
          .ref("images")
          .child(image.name)
          .getDownloadURL()
          .then((url) => {
            setUrl(url);
            setCaricamento(false);
          });
      }
    );
  }

  function uploadName() {
    const todoRef = firebase.database().ref("url");
    todoRef
      .push({
        link: url,
        prezzo: prezzo,
        titolo: titolo,
        catego: categoria,
        new: nuovo,
        inforamzioni: inforamzioni,
        disponibile: "si",
        progetto: progetto,
      })
      .then(setCaricato("Caricato con successo"));
  }

  function ilTitolo(e) {
    setTitolo(e.target.value);
  }
  function ilPrezzo(e) {
    setPrezzo(e.target.value);
  }

  function selectCategoria(e) {
    setCategoria(e.key);
  }
  function checkBox(e) {
    setNuovo(e.target.checked);
  }

  function infoNuove(e) {
    setInfomrazioni(e.target.value);
  }

  const menu = (
    <Menu onClick={selectCategoria}>
      <Menu.Item key="Anelli">
        <p>Anelli</p>
      </Menu.Item>
      <Menu.Item key="Bracciali">
        <p>Bracciali</p>
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item key="Collane">
        <p>Collane</p>
      </Menu.Item>
      <Menu.Item key="Orecchini">
        <p>Orecchini</p>
      </Menu.Item>
      <Menu.Item key="Ritratti">
        <p>Ritratti</p>
      </Menu.Item>
    </Menu>
  );

  function Progect(e) { }

  const menuNew = (
    <Menu onClick={Progect}>
      <Menu.Item key="new">
        <p>Nuovo progetto</p>
      </Menu.Item>
      <Menu.Item key="Anelli">
        <p>Anelli2</p>
      </Menu.Item>
    </Menu>
  );

  return (
    <div className="App">
      <div className="inputArea">
        <Dropdown overlay={menu} trigger={["click"]} value="ciao">
          <a className="ant-dropdown-link">
            Categoria <DownOutlined />
          </a>
        </Dropdown>
        <input type="file" onChange={handlerChange} />
        <Checkbox onChange={checkBox}>Prodotto nuovo ? </Checkbox>

        <input
          type="text"
          name=""
          id=""
          placeholder="Nome prodotto"
          onChange={ilTitolo}
        />
        <TextArea
          className="infoText"
          rows={4}
          placeholder="info"
          onChange={infoNuove}
        />
        <div className="prezzi">
          <input
            type="text"
            name=""
            id=""
            placeholder="Prezzo"
            onChange={ilPrezzo}
          />
        </div>
        <Progetto />
        <button onClick={uppload}>Visualizza</button>
      </div>
      <div className="cardaArea">
        <Card
          className="cart"
          hoverable
          style={{ width: 240 }}
          cover={<Image className="immagineCover" width={200} src={url} />}
        >
          <Spin spinning={caricamento} />
          <h3>{categoria}</h3>
          <Meta title={titolo} description={`${prezzo}€`} />

          <button className="uppload" onClick={uploadName}>
            Upload
          </button>
          <p>{caricato}</p>
        </Card>

      </div>
    </div>
  );
}

export default App;
